// The per-holding "Consent for candidate" settings: one label per field and per
// value. The General Settings editor offers them; read-only summaries of a
// snapshot of them (a Bulk Enquiry batch) show the same words.

// The files HR supplies under those settings, named as New Enquiry's fields
// name them. Keys are the backend's file kinds (enquiry_import FILE_KINDS).
export const FILE_KIND_LABEL = {
  ktp_photo: 'KTP photo',
  terms_condition: 'Terms and condition',
  job_application_form: 'Job application form',
}

export const CONSENT_SETTINGS = {
  ektp_upload_process: {
    label: 'E-KTP upload process',
    options: [
      { label: 'Uploaded by the HR', value: 'hr' },
      { label: 'Uploaded directly by the candidate', value: 'candidate' },
    ],
  },
  kyc_enabled: {
    label: 'KYC',
    options: [
      { label: 'On', value: true },
      { label: 'Off', value: false },
    ],
  },
  job_application_form_mode: {
    label: FILE_KIND_LABEL.job_application_form,
    options: [
      { label: 'Uploaded by the HR', value: 'hr' },
      { label: 'Uploaded directly by the candidate', value: 'candidate' },
      { label: 'Auto generated by system', value: 'auto' },
    ],
    // Read-only: a holding still on the legacy boolean (form disabled) resolves
    // to 'off'. Shown, never offered by the editor.
    legacyLabels: { off: 'Off' },
  },
  terms_condition_mode: {
    label: FILE_KIND_LABEL.terms_condition,
    options: [
      { label: 'Input by HR', value: 'hr' },
      { label: 'Input directly by the candidate', value: 'template' },
    ],
  },
}

// consent_config keys that are not editor settings but can still differ
// between a snapshot and the live settings (a Bulk Enquiry batch's
// consent_changes): the legacy on/off switch job_application_form_mode
// replaced. Only read-only summaries print them.
const LEGACY_SETTINGS = {
  job_application_form_enabled: {
    label: `${FILE_KIND_LABEL.job_application_form} (on/off)`,
    options: [
      { label: 'On', value: true },
      { label: 'Off', value: false },
    ],
  },
}

const settingOf = (key) => CONSENT_SETTINGS[key] || LEGACY_SETTINGS[key]

/** Name of one setting (an editor setting or a legacy key); an unknown key prints as itself. */
export function consentSettingName(key) {
  return settingOf(key)?.label ?? String(key)
}

/** Label of one setting value; an unknown value prints as itself. */
export function consentSettingLabel(key, value) {
  const setting = settingOf(key)
  const option = setting?.options.find((o) => o.value === value)
  if (option) return option.label
  return setting?.legacyLabels?.[value] ?? String(value ?? '—')
}
